module.exports = __webpack_public_path__ + "static/img/cast-aluminum-base.1470a33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/general-frames/cast-aluminum-base.jpg
// module id = 722
// module chunks = 0